<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col cols="6" class="text-sm-left mb-0">
        <span class="text-uppercase page-subtitle d-block">Lista</span>
        <h3 class="page-title d-inline">Indicações</h3>
      </d-col>
      <d-col cols="6" class="text-sm-right mb-0">
        <d-button @click="exportCSV()">Exportar CSV</d-button>
      </d-col>
    </d-row>

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="card-small mb-4">
          <form class="w-100">
            <div class="card-header border-bottom ">
              <d-form-row class="mb-3 d-flex justify-content-around">
                <d-col>
                  <h6 class="m-0">Indicações Ativos</h6>
                </d-col>
                <d-col>
                  <div class="input-group input-group-seamless ">
                    <div class="input-group-prepend">
                      <div class="input-group-text">
                        <i class="fas fa-search"></i>
                      </div>
                    </div>
                    <input
                      class="navbar-search form-control"
                      type="text"
                      placeholder="Procurar por algo..."
                      aria-label="Search"
                      v-model="pagination.search"
                    >
                  </div>
                </d-col>
              </d-form-row>
              <d-form-row class="d-flex gap-4 justify-content-end">
                <d-col cols="2" class="d-flex mb-4 mb-sm-0 justify-content-start">
                  <select-state :model.sync="pagination.state" :onChange="changeState"/>
                </d-col>
                <d-col cols="3" class="d-flex mb-4 mb-sm-0 justify-content-start">
                  <autocomplete
                    ref="autocompleteCity"
                    placeholder="Cidade"
                    :items="citiesOptions"
                    item-show="label"
                    :on-input="onInputCity"
                    :on-select="setCity"
                  ></autocomplete>
                </d-col>
                <d-col cols="3" class="d-flex mb-4 mb-sm-0 justify-content-start">
                  <autocomplete
                    v-if="isAdmin"
                    ref="autocomplete"
                    placeholder="Revendedor"
                    :items="resellers"
                    item-show="name"
                    :on-input="onInput"
                    :on-select="setReseller"
                  ></autocomplete>
                  <d-select
                    v-if="!isAdmin && options.length > 1"
                    v-model="pagination.reseller"
                    :options="options"
                    value-field="id"
                    text-field="name"
                  ></d-select>
                </d-col>
                <d-col cols="auto" class="d-flex mb-4 mb-sm-0 justify-content-start">
                  <d-input-group class="d-flex justify-content-left">
                    <d-datepicker v-model="pagination.date_from" placeholder="Data inicial" typeable/>
                    <d-datepicker v-model="pagination.date_to" placeholder="Data final" typeable/>
                    <d-input-group-text slot="append">
                      <i class="material-icons">&#xE916;</i>
                    </d-input-group-text>
                  </d-input-group>
                </d-col>
              </d-form-row>
            </div>
          </form>
          <div class="card-body p-0 pb-3 text-left">
            <div class="table-overflow">
              <lead-table :leads="leads.list"/>
            </div>
            <pagination :total-items="leads.total_items" :pagination.sync="pagination"></pagination>
          </div>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import SelectState from '_shared/SelectState.vue';
import { downloadCsvFile, cloneDeep, catchPdf } from '_utils';
import Autocomplete from '_shared/Autocomplete.vue';
import LeadService from '_services/rest/modules/lead';
import Pagination from '_shared/Pagination.vue';
import LeadTable from '../components/LeadListTable.vue';
import { _SET_RESELLER_ } from '../components/LeadModel';

const RESELLERS_OPTIONS = [
  { id: null, name: 'Todos' },
  { id: 'without', name: 'Nenhum associado' },
];

export default {
  name: 'lead-list',
  components: {
    Autocomplete,
    Pagination,
    LeadTable,
    SelectState,
  },
  data() {
    return {
      pagination: {
        city: null,
        take: 10,
        state: null,
        search: '',
        date_to: null,
        reseller: null,
        date_from: null,
        skip: (this.$route.params.page - 1) * 10,
        page: parseInt(this.$route.params.page, Number),
      },
      options: [],
      citiesOptions: [],
    };
  },
  computed: {
    leads() {
      const { leadList } = this.$store.state.lead;
      if (leadList && leadList.list.length) {
        return leadList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
    resellers() {
      const { resellerList } = this.$store.state.reseller;
      if (resellerList && resellerList.list.length) {
        resellerList.list.unshift(cloneDeep(RESELLERS_OPTIONS));
        return resellerList.list;
      }
      return cloneDeep(RESELLERS_OPTIONS);
    },
    isAdmin() {
      const { isAdmin } = this.$store.state.user;
      return isAdmin;
    },
  },
  methods: {
    ...mapActions([
      'checkAdmin',
      'getLeadList',
      'getResellerList',
    ]),
    exportCSV() {
      LeadService.download(this.pagination)
        .then(response => downloadCsvFile(response))
        .catch(error => this.activeAlert({ message: catchPdf(error.message), theme: 'danger' }));
    },
    getResellersOptions() {
      LeadService.getResellersOptions()
        .then(response => {
          if (response.length) {
            this.pagination.reseller = response[0].id;
            this.options = response;
          }
          this.getList();
        });
    },
    getCitiesOptions(cityName) {
      LeadService.getCitiesOptions(this.pagination.state, cityName)
        .then(response => {
          if (response.length) {
            this.citiesOptions = response;
          }
        });
    },
    getList() {
      this.getLeadList(this.pagination);
    },
    getReseller(name = '') {
      const params = {
        skip: 0,
        take: 10,
        search: name,
      };
      this.getResellerList(params);
    },
    onInput(name) {
      clearTimeout(this.searchTimeoutId);
      this.searchTimeoutId = setTimeout(() => {
        this.getReseller(name);
      }, 500);
    },
    setReseller(reseller) {
      this.pagination.page = 1;
      this.pagination.skip = 0;
      this.pagination.reseller = reseller.id;
    },
    onInputCity(name) {
      clearTimeout(this.searchTimeoutId);
      this.searchTimeoutId = setTimeout(() => {
        this.getCitiesOptions(name);
      }, 500);
    },
    setCity(option) {
      this.pagination.page = 1;
      this.pagination.skip = 0;
      this.pagination.city = option.value;
    },
    changeState() {
      this.pagination.city = null;
      this.$refs.autocompleteCity.$refs.input.value = null;
    },
  },
  mounted() {
    Events.$emit('sidebarVisible', false);
    Events.$on('update:pagination', pagination => {
      this.$router.push({ params: { page: pagination.page } });
      this.getCitiesOptions();
      this.getList();
    });
    this.checkAdmin();

    Events.$on(_SET_RESELLER_, reseller => {
      this.setReseller(reseller);
      this.getLeadList(this.pagination);
    });
    if (this.isAdmin) {
      return this.getList();
    }
    return this.getResellersOptions();
  },

};
</script>

<style lang="scss" scoped>
.vdp-datepicker input {
    height: 38px;
}
.gap-4 {
  gap: 1rem;
}
</style>
